export default __webpack_public_path__ + "static/media/work.99769bb4.svg";